<script>
import scrollMixin from '@/mixins/scrollWheelMixin';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import { required, integer, minValue } from 'vuelidate/lib/validators';

export default {
  components: {
    Tooltip,
  },
  data() {
    return {
      currentQuantity: 0,
    };
  },
  validations() {
    let initVal = {
      currentQuantity: { required, minValue: minValue(this.minQuantity) },
    };
    if (this.precision == '1') {
      initVal.currentQuantity.integer = integer;
    }

    return initVal;
  },
  mixins: [scrollMixin],
  props: {
    defaultQuantity: { type: Number, default: 0 },
    minQuantity: { type: Number, default: 0 },
    maxQuantity: { type: Number, default: 0 },
    precision: { type: String, default: '1' },
    isEditedQuantity: { type: Boolean, default: false },
    returnedObject: { default: null },
    target: { type: String, required: true },
    title: { type: String, required: true },
    placement: { type: String, default: 'left' },
  },
  methods: {
    showPopover() {
      this.currentQuantity = this.defaultQuantity;
      this.$v.currentQuantity.$reset();
    },
    popoverShown() {
      this.$refs[`${this.target}-input`].focus();
    },
    closePopover() {
      this.$refs[this.target + '-popover'].$emit('close');
    },
    saveEditedQuantity() {
      this.$v.currentQuantity.$touch();
      if (!this.$v.currentQuantity.$invalid) {
        this.$emit(
          'set-edited-quantity',
          this.currentQuantity,
          this.returnedObject
        );

        this.closePopover();
      }
    },
    removeEditedQuantity() {
      this.$emit('remove-edited-quantity', this.returnedObject);
      this.closePopover();
    },
    wheelEditPopoverQuantity(event) {
      this.currentQuantity = this.scrollMixinEvent(
        event,
        this.currentQuantity,
        this.minQuantity,
        this.maxQuantity
      );
    },
  },
};
</script>

<template>
  <b-popover
    :ref="target + '-popover'"
    :target="target"
    triggers="click blur"
    :placement="placement"
    @show="showPopover"
    @shown="popoverShown"
  >
    <template #title>
      <div class="flex-box">
        <div>{{ title }}</div>
        <div class="flex-push pl-3">
          <i
            class="fas fa-times text-secondary pl-2 pr-2"
            @click="closePopover()"
            style="cursor: pointer; font-size: 1.3em"
          ></i>
        </div>
      </div>
    </template>
    <div v-if="isEditedQuantity == false">
      <b-form-group
        id="input-group-price"
        style="width: 240px; padding-top: 10px"
      >
        <b-form-input
          type="number"
          :ref="target + '-input'"
          v-model="currentQuantity"
          :class="{
            'is-invalid': $v.currentQuantity.$error,
          }"
          :step="precision"
          :min="minQuantity"
          @wheel.prevent="wheelEditPopoverQuantity($event)"
          @keydown.enter.prevent="saveEditedQuantity()"
          tabindex="-1"
          :placeholder="$t('items.quantity')"
        ></b-form-input>
        <Tooltip :validations="$v.currentQuantity" />
      </b-form-group>
      <b-button block @click="saveEditedQuantity()">{{
        $t('general.update')
      }}</b-button>
    </div>
    <div v-else>
      <b-button block @click="removeEditedQuantity()">{{
        $t('general.cancel')
      }}</b-button>
    </div>
  </b-popover>
</template>
